<!-- TabletIcon.vue -->
<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <!-- Tablet outline -->
    <rect 
      x="4" 
      y="2" 
      width="16" 
      height="20" 
      rx="2" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    
    <!-- Screen area -->
    <rect 
      x="6" 
      y="4" 
      width="12" 
      height="14" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    
    <!-- Home button -->
    <circle 
      cx="12" 
      cy="20" 
      r="1" 
      fill="#333333"
    />
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>